// import { FaStar, FaCheckCircle } from "react-icons/fa";
// import { FiCalendar } from "react-icons/fi";
// import { FaQuoteLeft } from "react-icons/fa";
// import "./review.scss";

// const ReviewCard = ({ review }) => {
  
//   return (
//     <div className="testimonial-card">
//       <div className="card-inner">
//         <div className="card-header">
//           <div className="reviewer-info">
//             <div className="avatar">
//               {review.avatar ? (
//                 <img src={review.avatar} alt={review.name} />
//               ) : (
//                 <span>{review.name.charAt(0).toUpperCase()}</span>
//               )}
//             </div>
//             <div className="reviewer-details">
//               <h4 className="reviewer-name">{review.name}</h4>
//               <div className="reviewer-badges">
//                 <span className="badge verified">
//                   <FaCheckCircle /> Verified Traveler
//                 </span>
//                 {review.experience && (
//                   <span className="badge experience">{review.experience}</span>
//                 )}
//               </div>
//             </div>
//           </div>
//           <div className="review-meta">
//             <span className="review-date">
//               <FiCalendar /> {review.date}
//             </span>
//           </div>
//         </div>

//         <div className="rating-stars">
//           {[1, 2, 3, 4, 5].map((i) => (
//             <FaStar
//               key={i}
//               className={i <= review.stars ? "star active" : "star"}
//             />
//           ))}
//           <span className="rating-number">{review.stars}.0</span>
//         </div>

//         <div className="review-content">
//           <FaQuoteLeft className="quote-icon" />
//           <p className="review-message">{review.message}</p>
//         </div>

//         {review.tripDetails && (
//           <div className="trip-info">
//             <span className="trip-name">{review.tripDetails.name}</span>
//             <span className="trip-date"> • {review.tripDetails.date}</span>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }
    

// export default ReviewCard;
import { FaStar, FaCheckCircle, FaQuoteLeft } from "react-icons/fa";
import { FiCalendar } from "react-icons/fi";
import "./review.scss";

const ReviewCard = ({ review }) => {
  if (!review) return null;

  const name = review.name || "Guest";
  const stars = Number(review.stars) || 0;
  const message = review.message || "";
  const date = review.date || "";

  return (
    <div className="testimonial-card">
      <div className="card-header">
        <div className="reviewer-info">
          <div className="avatar">
            {review.avatar ? (
              <img src={review.avatar} alt={name} />
            ) : (
              <span>{name.charAt(0).toUpperCase()}</span>
            )}
          </div>

          <div className="reviewer-details">
            <h4 className="reviewer-name">{name}</h4>

            <div className="reviewer-badges">
              <span className="badge verified">
                <FaCheckCircle /> Verified Traveler
              </span>

              {review.experience && (
                <span className="badge experience">
                  {review.experience}
                </span>
              )}
            </div>
          </div>
        </div>

        {date && (
          <div className="review-meta">
            <span className="review-date">
              <FiCalendar /> {date}
            </span>
          </div>
        )}
      </div>

      <div className="rating-stars">
        {[1, 2, 3, 4, 5].map(i => (
          <FaStar
            key={i}
            className={i <= stars ? "star active" : "star"}
          />
        ))}
        <span className="rating-number">{stars}.0</span>
      </div>

      <div className="review-content">
        <FaQuoteLeft className="quote-icon" />
        <p className="review-message">{message}</p>
      </div>

      {review.tripDetails?.name && (
        <div className="trip-info">
          <span className="trip-name">{review.tripDetails.name}</span>
          {review.tripDetails.date && (
            <span className="trip-date">
              {" "}• {review.tripDetails.date}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default ReviewCard;
